import { Typography } from '@mui/material';
import { Row, Spacer } from '../../../components';
import { Svgs } from '../../../assets/svg';

const YourLifeGoals: React.FC = () => {
  return (
    <>
      <Spacer height='sm' />
      <Typography color='secondary' variant='p18SemiBold'>
        Your life goals–planned together, in one app.
      </Typography>
      <Row style={{ alignItems: 'center', gap: '20px', marginTop: '15px' }}>
        <Svgs.ArtTarget style={{ width: '135px', height: 'auto' }} />
        <Typography color='info.main' variant='body1'>
          When choices feel overwhelming, a clear guide changes everything. 3Nickels is your
          financial guide: see all your finances in one place and know what to do next. Less stress,
          more confidence, real progress.
        </Typography>
      </Row>
    </>
  );
};

export default YourLifeGoals;
